// extracted by mini-css-extract-plugin
module.exports = {"reviewModePanelContainer":"review-mode-panel_reviewModePanelContainer__tYycM"};